"use client";
import React from "react";
import stl from "../../styles/productSizeSwiper.module.scss";
import SizeSwiperClient from "./SizeSwiperClient";
import { useTranslation } from "@/src/i18n/client";
import classnames from "classnames";

export interface IProps {
    isHideTitle?: boolean;
    slidesToShow?: number;
}

const SizeSwiper: React.FC<IProps> = (props) => {
    const { t } = useTranslation("productDetail");
    return (
        <div className={stl["carouselParent"]}>
            <SizeSwiperClient {...props}>
                <p
                    className={classnames(stl["view-size"], {
                        [stl["hidden-bottom"]]: props.isHideTitle,
                    })}
                >
                    {t("productDetail:ViewSize")}
                </p>
            </SizeSwiperClient>
        </div>
    );
};

export default SizeSwiper;
